import React, { Component } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  CircularProgress,
  DialogActions,
  Button,
} from "@mui/material";
import { Cancel, CheckCircleOutline, ErrorOutline } from "@mui/icons-material";
const LoaderModal = ({
  loading,
  error,
  loaderMessage,
  openLoader,
  setOpenLoader,
  onSuccessButtonLable,
  onSuccessCallback,
  onErrorButtonLable,
  onErrorCallback,
}) => {
  return (
    <>
      <Dialog
        open={openLoader}
        // onClose={() => setOpenLoader(false)}
      >
        <DialogContent
          style={{
            width: 300,
            padding: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {loading ? (
            <CircularProgress />
          ) : error ? (
            <ErrorOutline color="error" style={{ fontSize: 50 }} />
          ) : (
            <CheckCircleOutline color="success" style={{ fontSize: 50 }} />
          )}
          {loaderMessage && (
            <Typography
              variant="subtitle1"
              style={{ fontSize: 13, lineHeight: 1.6, textAlign: "center" }}
            >
              {loaderMessage}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          {!error ? (
            <Button onClick={onSuccessCallback}>{onSuccessButtonLable}</Button>
          ) : (
            <Button onClick={onErrorCallback}>{onErrorButtonLable}</Button>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default LoaderModal;
